module.exports = __webpack_public_path__ + "static/media/lock_icon.a51e97b1.svg";